import { toIdentityObject } from '../../utils/array'
import adDimensionsConfig from './adDimensionsConfig'
import { create as makeEmptyObj, deepFreeze } from '../../utils/object'

const {
  d1x1,
  d160x600,
  d300x50,
  d300x250,
  d300x300,
  d300x600,
  d320x50,
  d728x90,
  d900x250,
  d970x250,
  d250x250,
} = adDimensionsConfig

const AD_TYPES = {
  REGULAR: 'RegularAd',
  PASSBACK: 'Passback',
  VIDEO: 'Video',
  INJECTED: 'Injected',
}

const BLOCK_NAME = 'ad'

const CLASS_NAMES = {
  BLOCK: BLOCK_NAME,
  STICKY: `${BLOCK_NAME}--fixed`,
  EMPTY: `${BLOCK_NAME}--empty`,
  INJECTED: `${BLOCK_NAME}--injected`,
  DFP: `${BLOCK_NAME}--dfp`,
}

const ADS_QUERYSTRING_OVERRIDE_PREFIX = 'ads'
const ADS_QUERYSTRING_OVERRIDE_PREFIXES = {
  toString: () => ADS_QUERYSTRING_OVERRIDE_PREFIX,
  CUSTOM_CRITERIA: `${ADS_QUERYSTRING_OVERRIDE_PREFIX}Cc`,
}

const DISPLAY_FORMAT_NAMES = [
  'Top',
  'Side',
  'SideSecondary',
  'Bottom',
  'InArticle',
  '1x1',
  '1x1secondary',
  'Outofpage',
  'InArticleDynamic',
  'RailRight',
  'InSlideshow',
  '1x1third',
]
const VIDEO_FORMAT_NAMES = ['Video', 'Vinarticle', 'Vside']
const AD_FORMAT_NAMES = [...DISPLAY_FORMAT_NAMES, ...VIDEO_FORMAT_NAMES]
let AD_FORMATS = makeEmptyObj()
AD_FORMAT_NAMES.forEach(toIdentityObject, AD_FORMATS)
deepFreeze(AD_FORMATS)

const adsConfig = {
  global: {
    doubleClick: {},
  },

  slot: {
    [AD_FORMATS.Video]: {
      type: AD_TYPES.VIDEO,
      doubleClick: {
        dimensions: {
          desktop: [[640, 360]],
        },
      },
    },
    [AD_FORMATS.Top]: {
      type: AD_TYPES.REGULAR,
      doubleClick: {
        isSticky: {
          portraitTablet: {
            default: true,
            exceptOnSites: [],
          },
          mobile: {
            default: true,
            exceptOnSites: [],
          },
          desktop: {
            default: false,
            exceptOnSites: [],
          },
        },
        slotDivId: `div-gpt-ad-1430753718702-0-${AD_FORMATS.Top}`,
        dimensions: {
          desktop: [d728x90, d900x250, d970x250],
          landscapeTablet: [d728x90],
          portraitTablet: [d728x90],
          mobile: [d300x50, d320x50],
        },
      },
    },
    [AD_FORMATS.Side]: {
      type: AD_TYPES.REGULAR,
      doubleClick: {
        hideForHorizonalBreakpoint: true,
        slotDivId: `div-gpt-ad-1430753718702-0-${AD_FORMATS.Side}`,
        dimensions: {
          desktop: [d300x250, d300x600],
        },
      },
    },
    [AD_FORMATS.SideSecondary]: {
      type: AD_TYPES.REGULAR,
      doubleClick: {
        // hideForLocale: 'en',
        hideForHorizonalBreakpoint: true,
        slotDivId: `div-gpt-ad-1430753718702-0-${AD_FORMATS.SideSecondary}`,
        dimensions: {
          desktop: [d300x250, d300x600],
        },
      },
    },
    [AD_FORMATS.InSlideshow]: {
      type: AD_TYPES.REGULAR,
      doubleClick: {
        slotDivId: `div-gpt-ad-1430753718702-0-${AD_FORMATS.InSlideshow}`,
        dimensions: {
          desktop: [d300x250, d300x300, d728x90],
        },
      },
    },
    // [AD_FORMATS.Bottom]: {
    //   type: AD_TYPES.REGULAR,
    //   doubleClick: {
    //     slotDivId: `div-gpt-ad-1430753718702-0-${ AD_FORMATS.Bottom }`,
    //     dimensions: {
    //       desktop: [d728x90, ],
    //       mobile: [d300x50, d320x50, ],
    //     },
    //   },
    // },
    [AD_FORMATS.InArticle]: {
      type: AD_TYPES.INJECTED,
      doubleClick: {
        hideForNonMobile: true,
        slotDivId: `div-gpt-ad-1430753718702-0-${AD_FORMATS.InArticle}`,
        dimensions: {
          mobile: [d300x250, d300x300, d250x250],
        },
      },
    },
    [AD_FORMATS.InArticleDynamic]: {
      type: AD_TYPES.INJECTED,
      doubleClick: {
        isEnabledInNativeApp: true,
        hideForNonMobile: true,
        slotDivId: `div-gpt-ad-1430753718702-0-${AD_FORMATS.InArticleDynamic}`,
        dimensions: {
          mobile: [d300x250, d300x300, d250x250],
        },
      },
    },
    //yoni- removed follow by sharon request april 2018
    // [AD_FORMATS.Outofpage]: {
    //   type: AD_TYPES.REGULAR,
    //   doubleClick: {
    //     slotDivId: `div-gpt-ad-1462695772762-0-${AD_FORMATS.Outofpage}`,
    //     isOutOfPage: true,
    //   },
    // },
    [AD_FORMATS['1x1secondary']]: {
      type: AD_TYPES.REGULAR,
      hideSlotContainer: true,
      doubleClick: {
        slotDivId: `div-gpt-ad-1430753718702-0-${AD_FORMATS['1x1secondary']}`,
        isEnabledInNativeApp: false,
        hideForNonMobile: false,
        dimensions: {
          desktop: [d1x1],
          mobile: [d1x1],
        },
      },
    },
    [AD_FORMATS['1x1third']]: {
      type: AD_TYPES.REGULAR,
      hideSlotContainer: true,
      doubleClick: {
        slotDivId: `div-gpt-ad-1430753718702-0-${AD_FORMATS['1x1third']}`,
        isEnabledInNativeApp: false,
        hideForNonMobile: false,
        dimensions: {
          desktop: [d1x1],
          mobile: [d1x1],
        },
      },
    },
    [AD_FORMATS.RailRight]: {
      type: AD_TYPES.REGULAR,
      hideSlotContainer: true,
      doubleClick: {
        slotDivId: `div-gpt-ad-1430753718702-0-${AD_FORMATS.RailRight}`,
        hideForHorizonalBreakpoint: true,
        dimensions: {
          desktop: [d160x600],
        },
      },
    },
  },
}

export { adsConfig, AD_TYPES, ADS_QUERYSTRING_OVERRIDE_PREFIXES, AD_FORMATS, CLASS_NAMES }



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/config/adsConfig.js